import { HttpStatusCode } from "types/types";

import {
  type PersonalizationClientErrorParams,
  type PersonalizationErrorResponse,
} from "./types";

export class PersonalizationClientError extends Error {
  url: string;
  errorResponse: PersonalizationErrorResponse;
  status: HttpStatusCode;

  constructor({
    errorResponse,
    status,
    url,
  }: PersonalizationClientErrorParams) {
    super(JSON.stringify(errorResponse));
    this.name = "PersonalizationClientError";
    this.status = status;
    this.url = url;
    this.errorResponse = errorResponse;
  }
}
